import * as React from "react";
import { useCommonHooks, useEditRouteParams } from "../../../hooks";
import { useQuery } from "react-query";
import { ERoutes } from "../../../AppRouter";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { BackButton, PageBase } from "../../../components";
import CancellationReasonDetailPanel from "./CancellationReasonDetailPanel";

export interface ICancellationReasonItemPageProps {}

export const CancellationReasonItemPage: React.FunctionComponent<
  ICancellationReasonItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["objective-question-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.cancellationReasons.getDisplayName(+id);
      }
      return t("NewCancellationReason");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      { text: t("CancellationReasonList"), route: ERoutes.cancellationReasons },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.cancellationReasons}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.cancellationReasons} />
        <Tab
          id="details"
          title={t("Details")}
          panel={<CancellationReasonDetailPanel cancellationReasonId={+id} />}
        />
      </Tabs>
    </PageBase>
  );
};

export default CancellationReasonItemPage;
